import type { HappyHourView } from 'shared-models/browser';
import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';

export type { HappyHourView } from 'shared-models/browser';

export type ActivateHappyHourPayload = {
  categoryIds: number[];
  startTime: string;
  endTime: string;
  activeDays: number[];
  dayOverrides?: Array<{ day: number; startTime: string; endTime: string }>;
  discountPct: number;
};

class HappyHourService {
  async get(tenantId: string, employeeSession: string): Promise<HappyHourView> {
    try {
      const response = await authenticatedInstance.get<HappyHourView>(
        `/happy-hour/tenant/${tenantId}`,
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'Failed loading happy hour'));
    }
  }

  async activate(
    tenantId: string,
    payload: ActivateHappyHourPayload,
    employeeSession: string,
  ): Promise<void> {
    try {
      await authenticatedInstance.patch(
        `/happy-hour/tenant/${tenantId}/activate`,
        payload,
        { headers: { 'x-employee-session': employeeSession } },
      );
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'Failed activating happy hour'));
    }
  }

  async deactivate(tenantId: string, employeeSession: string): Promise<void> {
    try {
      await authenticatedInstance.patch(
        `/happy-hour/tenant/${tenantId}/deactivate`,
        {},
        { headers: { 'x-employee-session': employeeSession } },
      );
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'Failed deactivating happy hour'));
    }
  }
}

export const happyHourService = new HappyHourService();